export enum VehicleAttribution {
  affected = 'AFFECTED',
  mutualized = 'MUTUALIZED',
}
